// src/components/Banner.tsx
'use client'

import React from 'react'
import type {
  CookieConsentConfig,
  TextsConfig,
  CategoryDefinition,
  ConsentState,
  StyleConfig,
} from '../types'
import { BannerDefault } from './presets/BannerDefault'
import { BannerMinimal } from './presets/BannerMinimal'
import { BannerCard } from './presets/BannerCard'
import { BannerSidebar } from './presets/BannerSidebar'
import { BannerMeui } from './presets/BannerMeui'

export interface BannerProps {
  config: CookieConsentConfig
  texts: TextsConfig
  categories: CategoryDefinition[]
  consent: ConsentState
  onAccept: () => void
  onDecline: () => void
  onOpenSettings: () => void
  onClose: () => void
  onConsentChange?: (categoryId: string, enabled: boolean) => void
  accentColor: string
  style: Required<StyleConfig>
}

/**
 * Banner wrapper - routes to appropriate preset
 * All presets now use inline positioning for reliability
 */
export function Banner(props: BannerProps) {
  const preset = props.config.preset || 'default'

  // Render appropriate preset
  switch (preset) {
    case 'meui':
      return <BannerMeui {...props} />
    case 'minimal':
      return <BannerMinimal {...props} />
    case 'card':
      return <BannerCard {...props} />
    case 'sidebar':
      return <BannerSidebar {...props} />
    case 'default':
    default:
      return <BannerDefault {...props} />
  }
}
